export default function SyncableEndnoteChangeController(
) {
  const vm = this;

  _activate();

  function _activate() {
    console.log(vm);
  }
}

SyncableEndnoteChangeController.$inject = [
];
